<div class="page-wrapper">
    <H4 style="font-size: 18px; font-weight: bolder; margin-bottom: 20px;"> DASHBOARD</H4>

    <div class="admin-dashboard-cards">
        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <img src="/assets/icons/stock-icon-rounded.svg" alt="">



            <div class="content">

                <div class="top">
                    <span class="title">
                        Today

                        @if(dashboardCardsData?.dailyDate?.totalCount || dashboardCardsData?.dailyDate?.totalCount ==
                        0){
                        ({{dashboardCardsData?.dailyDate?.totalCount | number}})
                        }
                    </span>
                    <button (click)="goToSummary('TODAY')">See More
                        <svg width="8" height="8" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0.6875 3.24121L3.0246 0.904113L0.6875 3.24121Z" fill="#02632A" />
                            <path d="M0.6875 3.24121L3.0246 0.904113" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.6875 0.904113H3.0246V3.24121" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="card-value">

                    @if(dashboardCardsData?.dailyDate?.totalAmount || dashboardCardsData?.dailyDate?.totalAmount == 0){
                    {{dashboardCardsData?.dailyDate?.totalAmount | nairaCurrency}}
                    }
                    @else {

                    @if(errorFetchingCardData) {
                    <span class="text-muted">--</span>
                    }
                    @else {
                    <div class="spinner-light"></div>
                    }

                    }

                </div>



                <div class="d-flex gap-1" style="font-size: 10px">
                    @if(dashboardCardsData?.dailyDate?.percentage || dashboardCardsData?.dailyDate?.percentage == 0){

                    <span class="percentage"
                        [ngStyle]="{ color: getPercentageColor(dashboardCardsData?.dailyDate?.percentage)}">
                        {{dashboardCardsData?.dailyDate?.percentage | signedPercentage }}
                    </span>
                    }
                </div>
            </div>
        </div>

        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <img src="/assets/icons/stock-icon-rounded.svg" alt="">



            <div class="content">

                <div class="top">
                    <span class="title">
                        This Week

                        @if(dashboardCardsData?.weeklyDate?.totalCount || dashboardCardsData?.weeklyDate?.totalCount ==
                        0){
                        ({{dashboardCardsData?.weeklyDate?.totalCount | number}})
                        }
                    </span>
                    <button (click)="goToSummary('WEEK')">See More
                        <svg width="8" height="8" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0.6875 3.24121L3.0246 0.904113L0.6875 3.24121Z" fill="#02632A" />
                            <path d="M0.6875 3.24121L3.0246 0.904113" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.6875 0.904113H3.0246V3.24121" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="card-value">

                    @if(dashboardCardsData?.weeklyDate?.totalAmount || dashboardCardsData?.weeklyDate?.totalAmount ==
                    0){
                    {{dashboardCardsData?.weeklyDate?.totalAmount | nairaCurrency}}
                    }
                    @else {

                    @if(errorFetchingCardData) {
                    <span class="text-muted">--</span>
                    }
                    @else {
                    <div class="spinner-light"></div>
                    }

                    }

                </div>



                <div class="d-flex gap-1" style="font-size: 10px">
                    @if(dashboardCardsData?.weeklyDate?.percentage || dashboardCardsData?.weeklyDate?.percentage == 0){

                    <span class="percentage"
                        [ngStyle]="{ color: getPercentageColor(dashboardCardsData?.weeklyDate?.percentage)}">
                        {{dashboardCardsData?.weeklyDate?.percentage | signedPercentage }}
                    </span>


                    }
                </div>
            </div>
        </div>

        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <img src="/assets/icons/stock-icon-rounded.svg" alt="">



            <div class="content">

                <div class="top">
                    <span class="title">
                        This Month

                        @if(dashboardCardsData?.monthlyDate?.totalCount || dashboardCardsData?.monthlyDate?.totalCount
                        == 0){
                        ({{dashboardCardsData?.monthlyDate?.totalCount | number}})
                        }
                    </span>
                    <button (click)="goToSummary('MONTH')">See More
                        <svg width="8" height="8" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0.6875 3.24121L3.0246 0.904113L0.6875 3.24121Z" fill="#02632A" />
                            <path d="M0.6875 3.24121L3.0246 0.904113" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.6875 0.904113H3.0246V3.24121" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="card-value">

                    @if(dashboardCardsData?.monthlyDate?.totalAmount || dashboardCardsData?.monthlyDate?.totalAmount ==
                    0){
                    {{dashboardCardsData?.monthlyDate?.totalAmount | nairaCurrency}}
                    }
                    @else {

                    @if(errorFetchingCardData) {
                    <span class="text-muted">--</span>
                    }
                    @else {
                    <div class="spinner-light"></div>
                    }

                    }

                </div>



                <div class="d-flex gap-1" style="font-size: 10px">
                    @if(dashboardCardsData?.monthlyDate?.percentage || dashboardCardsData?.monthlyDate?.percentage ==
                    0){

                    <span class="percentage"
                        [ngStyle]="{ color: getPercentageColor(dashboardCardsData?.monthlyDate?.percentage)}">
                        {{dashboardCardsData?.monthlyDate?.percentage | signedPercentage }}
                    </span>


                    }
                </div>
            </div>
        </div>



        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <img src="/assets/icons/stock-icon-rounded.svg" alt="">



            <div class="content">

                <div class="top">
                    <span class="title">
                        This Year

                        @if(dashboardCardsData?.yearlyDate?.totalCount || dashboardCardsData?.yearlyDate?.totalCount ==
                        0){
                        ({{dashboardCardsData?.yearlyDate?.totalCount | number}})
                        }
                    </span>
                    <button (click)="goToSummary('YEAR')">See More
                        <svg width="8" height="8" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0.6875 3.24121L3.0246 0.904113L0.6875 3.24121Z" fill="#02632A" />
                            <path d="M0.6875 3.24121L3.0246 0.904113" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.6875 0.904113H3.0246V3.24121" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>

                <div class="card-value">

                    @if(dashboardCardsData?.yearlyDate?.totalAmount || dashboardCardsData?.yearlyDate?.totalAmount ==
                    0){
                    {{dashboardCardsData?.yearlyDate?.totalAmount | nairaCurrency}}
                    }
                    @else {

                    @if(errorFetchingCardData) {
                    <span class="text-muted">--</span>
                    }
                    @else {
                    <div class="spinner-light"></div>
                    }

                    }

                </div>



                <div class="d-flex gap-1" style="font-size: 10px">
                    @if(dashboardCardsData?.yearlyDate?.percentage || dashboardCardsData?.yearlyDate?.percentage == 0){
                    <span class="percentage"
                        [ngStyle]="{ color: getPercentageColor(dashboardCardsData?.yearlyDate?.percentage)}">
                        {{dashboardCardsData?.yearlyDate?.percentage | signedPercentage }}
                    </span>
                    }
                </div>
            </div>
        </div>

        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <img src="/assets/icons/stock-icon-rounded.svg" alt="">



            <div class="content">

                <div class="top">

                    <span class="title">
                        Total Collections
                    </span>

                    <!-- <button (click)="goToSummary('YEAR')">
                        See More
                        <svg width="8" height="8" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M0.6875 3.24121L3.0246 0.904113L0.6875 3.24121Z" fill="#02632A" />
                            <path d="M0.6875 3.24121L3.0246 0.904113" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M0.6875 0.904113H3.0246V3.24121" stroke="#02632A" stroke-width="0.46742"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button> -->
                </div>

                <div class="card-value">

                    @if(dashboardCardsData?.collectionDate?.totalAmount ||
                    dashboardCardsData?.collectionDate?.totalAmount ==
                    0){
                    {{dashboardCardsData?.collectionDate?.totalAmount | nairaCurrency}}
                    }
                    @else {

                    @if(errorFetchingCardData) {
                    <span class="text-muted">--</span>
                    }
                    @else {
                    <div class="spinner-light"></div>
                    }

                    }

                </div>

            </div>
        </div>


    </div>


    <div class="collections">
        <div class="top">
            <div class="d-flex flex-column gap-2 ">
                <span style="color: #93A3AB; font-size: 17px; font-weight: 500;">Collections</span>
                <p class="card-value">{{lineChartTotal | nairaCurrency }}</p>
                <div class="d-flex gap-2 ">
                    <span class="percentage" [ngStyle]="{ color: getPercentageColor(lineChartPercentage)}">
                        {{ lineChartPercentage | signedPercentage}}
                    </span>

                </div>
            </div>

            <div class="filter">
                <div class="item" [ngClass]="{'active': activeFilter == 'TODAY'}" (click)="setActiveFilter('TODAY')">
                    Today
                </div>
                <div class="item" [ngClass]="{'active': activeFilter == 'WEEK'}" (click)="setActiveFilter('WEEK')">
                    Week
                </div>
                <div class="item" [ngClass]="{'active': activeFilter == 'MONTH'}" (click)="setActiveFilter('MONTH')">
                    Month
                </div>
                <div class="item" [ngClass]="{'active': activeFilter == 'YEAR'}" (click)="setActiveFilter('YEAR')">
                    Year
                </div>
            </div>


        </div>

        <div class="graph mt-3">
            <ngx-charts-line-chart [scheme]="colorScheme" [legend]="legend" [showXAxisLabel]="showXAxisLabel"
                [showYAxisLabel]="showYAxisLabel" [xAxis]="xAxis" [yAxis]="yAxis" [xAxisLabel]="xAxisLabel"
                [yAxisLabel]="yAxisLabel" [timeline]="timeline" [results]="lineChartData"
                [legendPosition]="legendPosition.Below">
            </ngx-charts-line-chart>
        </div>
    </div>

</div>

<!-- <app-bounce-loader></app-bounce-loader> -->